// extracted by mini-css-extract-plugin
export default {"root":"IconLanguages_root__juHcB"};